import React from "react";
import { Typography, Divider, Grid, Paper, TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";

export default function AddressSection({
  address,
  updatedAddress,
  inputErrors,
  editMode,
  handleAddressChange,
}) {
  return (
    <>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 4 }} color="#00438E">
        <FormattedMessage id="address.address_details" />
      </Typography>
      <Divider sx={{ mb: 2, borderColor: "#00438E" }} />
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 2,
          borderLeft: "4px solid #00438E",
          backgroundColor: "#ffffff",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.address_line_1" />}
              name="address_line_1"
              value={updatedAddress.address_line_1}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.address_line_1}
              helperText={inputErrors.address_line_1}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.address_line_2" />}
              name="address_line_2"
              value={updatedAddress.address_line_2}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.address_line_2}
              helperText={inputErrors.address_line_2}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.city" />}
              name="city"
              value={updatedAddress.city}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.city}
              helperText={inputErrors.city}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.state" />}
              name="state"
              value={updatedAddress.state}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.state}
              helperText={inputErrors.state}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.country" />}
              name="country"
              value={updatedAddress.country}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.country}
              helperText={inputErrors.country}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={<FormattedMessage id="address.postal_code" />}
              name="postal_code"
              value={updatedAddress.postal_code}
              onChange={handleAddressChange}
              disabled={!editMode}
              error={!!inputErrors.postal_code}
              helperText={inputErrors.postal_code}
              sx={{
                "& .MuiInputLabel-root": { color: "#00438E" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#00438E" },
                  "&:hover fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-focused fieldset": { borderColor: "#4A87C8" },
                  "&.Mui-disabled fieldset": { borderColor: "#e0e0e0" },
                },
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "rgba(0, 0, 0, 0.38)",
                },
              }}
            />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}